"use strict";
import { UploadManagerWrap } from "@/utils/UploadManager";
import { UploadVDManagerWrap } from "@/utils/UploadVDManager";
import { UploadPayPalManagerWrap } from "@/utils/UploadPayPalManager";
import Vue from "vue";
import Vuex from "vuex";
import AccountStore from "./account";
import matomoConfig from "@/configuration/matomoConfig";
Vue.use(Vuex);
export const store = new Vuex.Store({
  state: {
    uploadManager: new UploadManagerWrap(),
    uploadVDManager: new UploadVDManagerWrap(),
    uploadPayPalManager: new UploadPayPalManagerWrap(),
    matomo: matomoConfig
  },
  // getters: {
  //   historyTaskSuccessList: state => state.uploadManager.isUploadSuccess
  // },
  actions: {
    // 埋点
    matomo({ state }, { that, e }) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      let currentTarget = e == null ? void 0 : e.target;
      if (((_a = currentTarget == null ? void 0 : currentTarget.tagName) == null ? void 0 : _a.toLowerCase()) === "input") {
        return false;
      }
      let matomoId = ((_b = currentTarget == null ? void 0 : currentTarget.dataset) == null ? void 0 : _b.matomo) || ((_d = (_c = currentTarget == null ? void 0 : currentTarget.parentNode) == null ? void 0 : _c.dataset) == null ? void 0 : _d.matomo) || ((_g = (_f = (_e = currentTarget == null ? void 0 : currentTarget.parentNode) == null ? void 0 : _e.parentNode) == null ? void 0 : _f.dataset) == null ? void 0 : _g.matomo);
      if (matomoId) {
        let index = state.matomo.findIndex((item) => {
          return item.id === matomoId;
        });
        if (index !== -1) {
          let { category, action, name, value } = (_h = state.matomo[index]) == null ? void 0 : _h.config;
          that.$matomo.trackEvent(category, action, name, value);
        }
      }
    }
  },
  modules: {
    account: AccountStore
  }
});
